import { Component, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ExportDataService } from '../../../../shared';
import { MaintenanceService } from '../../../../techopsv4/services/maintenanceService';
import * as _ from 'lodash';
import { environment } from '../../../../../environments/environment';
import { SharedService } from '../../../../shared/services/shared.service';
import { SharedAuthService } from '../../../../shared/shared.auth.service';
import { CapitalMaintenanceV4Component } from '../capital-maintenance-table/capital-maintenance-table.component';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-ucmg-list-view',
    templateUrl: './ucmg-list-view.component.html',
    styleUrl: './ucmg-list-view.component.scss',
    standalone: false
})
export class UCMGListViewComponent {
  @ViewChild(CapitalMaintenanceV4Component) capTableComponent: CapitalMaintenanceV4Component;
  ucmgView: any;
  leadersData: any;
  currentTable: string = 'ucmg-segment-view';
  fundingOwner: any;
  fundingDelegateList: any[] = [];
  dataSourceDetails: MatTableDataSource<any>;
  olddatasource: any;
  UCMGDetailsList: any;
  tempFilterSegment: any;
  yearList:any = [];
  statusList:any = [];
  fundingSegmentList:any = [];
  ucmgYear:any;
  selectedStatusList = [];
  selectedFundingSegmentList = [];
  ucmgSelected: any[] = ["Green", "Blue", "Yellow", "Red"];
  totalApps: any = { green: "-", blue: "-", yellow: "-", red: "-"};
  totalCurrency: any = {green: "-", blue: "-", yellow: "-", red: "-"}
  filteredTotals: any = null; // Store filtered data totals
  tabledata: any = [];
  selectedRow: any = [];
  sort: any;
  TABLE_CONFIG: any = {
    pageSize: 10,
    pageIndex: 0,
    totalItems: 10,
    selection: true,
    edit: false,
    serverSidePagination: false,
    deleteFeature: true,
    expandable: true,
    innerTableEdit: false,
    isOptum: true
  };
  TABLE_COLUMNS : any = [];
  restrictionInvesterEdit:boolean = false;
  FILTER_OPTIONS: any = {}
  sortConfig = {
    active: 'Full_Name',
    direction: 'asc',
  }
  showLoader: boolean;
  searchField: any;
  segmentName: any;
  ucmgId: any;
  fundSegId:any;
  fiscalYear: any;
  investmentStatus: any;
  fundSegment: any;
  displayedColumns: any;
  ucmgIdFilterApplied : boolean[] = [false];
  ucmgNameFilterApplied : boolean[] = [false];
  ucmgListTable: boolean = true;
  accessDataSet: boolean =false;
  lobDataSet: boolean =false;
  filterClickedFirstTime: boolean = false;
  fundingOwnerList: any[] = [];
  investmentStatusList: any;
  portfolioManagerList: any[] = [];
  ucmgOwnerList: any[] = [];
  selectedPortfolioManagerList: any[] = [];
  selectedUcmgOwnerList: any[] = [];
  previousSelectedPMList: any[] = [];
  previousSelectedUCMGOList: any[] = [];
  isPortfolioManager: boolean = false;
  isUCMGOwner: boolean = false;
  segData: any;
  ucmgOwnerListFullCapacity: number;
  portfolioManagerListFullCapacity: number;
  totals: any = { totalACAP: 0, totalOptumTechLabor: 0, totalLeaderOTAllocation: 0 };
  portfolioManagerPlaceholder = 'Portfolio Manager';
  ucmgOwnerPlaceholder = 'UCMG Owner';

  constructor(
    public maintenanceService: MaintenanceService,
    public exportService: ExportDataService,
    private toaster: ToastrService,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private sharedAuthService: SharedAuthService,
    private router: Router
  ) { }

  ngOnInit() {  
    this.statusList = [{name:'Active'},{name:'Inactive'}];
    this.route.queryParams.subscribe(params => {
      if(params['segmentView']){
        this.ucmgView = 'segmentView'
      }
      if(params['leaderView']){
        this.currentTable = 'ucmg-leader-view';
        this.ucmgView = 'leaderView'
        this.leadersData = this.formatLeadersData(params['L1LeaderName'], params['L2LeaderName'], params['L3LeaderName']);
      }
      if(params['selectedStatus']){
        const statusArray = JSON.parse(params['selectedStatus']); // Fixed unterminated string literal
        console.log('Restoring investment status:', statusArray);
        
        // Clear selectedStatusList first
        this.selectedStatusList = [];
        
        // Only add items from statusList that exist in statusArray
        statusArray.forEach(statusItem => {
          const matchingIndex = this.statusList.findIndex(listItem => listItem.name === statusItem.name);
          if (matchingIndex !== -1) {
            // Only push the matching item from statusList if it exists in statusArray
            this.selectedStatusList.push(this.statusList[matchingIndex]);
          }
        });
        this.setSelectedValues({data: this.selectedStatusList});
      }
      this.configureTableColumns();
      this.fundSegId = params['Funding_SegmentID'];
      this.ucmgYear =  params['fiscalYear'] ? {name: parseInt(params['fiscalYear'])} : {name: new Date().getFullYear()};

    });
    this.displayedColumns = this.TABLE_COLUMNS.map(element => element.key);
    this.yearList = [{name:new Date().getFullYear()} ,{name: new Date().getFullYear()+1}];
    this.getUcmgDetails();
    if (!sessionStorage.getItem('techaccessData')) {
      this.sharedAuthService.userAccessDataSource.pipe(take(1)).subscribe(accessData => {
        this.fundOwnerRestrictionEdit();
      });
    } else {
      this.fundOwnerRestrictionEdit();
    }
    this.searchField = this.route.snapshot.queryParams['searchedText'] || '';
    this.searchDataSet();
  }

  ngOnChanges() {
    if (!sessionStorage.getItem('techaccessData')) {
      this.sharedAuthService.userAccessDataSource.pipe(take(1)).subscribe(accessData => {
        this.fundOwnerRestrictionEdit();
      });
    } else {
      this.fundOwnerRestrictionEdit();
    }
  }

  dataRefresh(event){
    if(event){
      this.getUcmgDetails();
    }
  }

  setUCMGOwnerRole(response){
    if (!response || !Array.isArray(response.ucmgs)) return;
    let curUserMsid =this.sharedAuthService.getMsid();
    response.ucmgs.some(ucmg => {
      if(ucmg.UCMG_Owner_MSID === curUserMsid && 
        ucmg.FOMSID !== curUserMsid &&
        !(this.sharedAuthService.getFundingAccessDetails('')) &&!(this.sharedAuthService.getFundingAccessDetails(ucmg.Funding_SegmentID,'Funding_Delegate'))
      ){ 
        this.isUCMGOwner = true;
        ucmg['isUCMGOwner'] = true;
        this.removeActionInExpandColumns();
        return true;
      }
      return false;
    });
  }

  setPortfolioManagerRole(response){
    if (!response || !Array.isArray(response.ucmgs)) return;
    let curUserMsid =this.sharedAuthService.getMsid();
    response.ucmgs.forEach(ucmg => {
      if(ucmg.Portfolio_Manager_MSID === curUserMsid && 
          ucmg.FOMSID !== curUserMsid &&
           !(this.sharedAuthService.getFundingAccessDetails('')) &&!(this.sharedAuthService.getFundingAccessDetails(ucmg.Funding_SegmentID,'Funding_Delegate'))
      ) {
        this.isPortfolioManager = true;
        ucmg['isPortfolioManager'] = true;
      }
    });
    if(this.isPortfolioManager){
      this.removeActionInExpandColumns();
      this.haveUCMGDetails(response);
    } 
  }

  fundOwnerRestrictionEdit() {
    const index = this.TABLE_COLUMNS.findIndex((ele) => ele.key === 'Actions');
    if (index >= 0){
      this.TABLE_COLUMNS.splice(index, 1);
    }
    this.restrictionInvesterEdit = this.sharedAuthService.getFundingAccessDetails('');
    if (this.restrictionInvesterEdit && !this.isPortfolioManager) {
      this.addActionInExpandColumns();
    }else{
      let segmentAccess = this.sharedAuthService.getFundingAccessDetails(this.fundSegId);
      if(segmentAccess && !this.isPortfolioManager)
        this.addActionInExpandColumns();
    }
  }

  addActionInExpandColumns(){
    if(this.ucmgView === 'segmentView'){
    this.TABLE_COLUMNS.push(
      {
        key: 'Actions',
        label: 'Action',
        width: '8% !important',
        textAlign: 'center !important',
        padding: "5px 1rem 5px 5px",
        paddingHeader: "0 1.5% 0 .5% !important",
        sortable:false,
        isLastColumn: true
      }
    );
    this.TABLE_COLUMNS.forEach(column => {
      if(column.key === 'Professional_Fees'){ column.isLastColumn = false; }
    });
    } else if(this.ucmgView === 'leaderView'){
      this.TABLE_COLUMNS.push(
        {
          key: 'Actions',
          label: 'Action',
          width: '8% !important',
          textAlign: 'center !important',
          padding: "5px 1rem 5px 5px",
          paddingHeader: "0 0% 0 4% !important",
          sortable: false,
          isLastColumn: true
        }
      );
      //for leader view loop thru TABLE_COLUMNS and set isLastColumn to false for Leader OT Allocation column
      this.TABLE_COLUMNS.forEach(column => {
        if(column.key === 'Leader_OT_Allocation'){ column.isLastColumn = false; }
      });  
    }
  }

  removeActionInExpandColumns() {
    const index = this.TABLE_COLUMNS.findIndex((ele) => ele.key === 'Actions');
    if (index >= 0){
      this.TABLE_COLUMNS.splice(index, 1);
    }
  }

  checkUCMGSelected(ucmgState){
    if(this.ucmgSelected.includes(ucmgState)){
      return true;
    }
    return false;
  }

  ucmgSelect(ucmgState){
    this.ucmgSelected =this.ucmgSelected.length==4 ? [] : this.ucmgSelected;
    this.filterClickedFirstTime = true;
    if(ucmgState && ucmgState != '' && ucmgState != 'Blue'){
      const ucmgIndex = this.ucmgSelected.indexOf(ucmgState)
      ucmgIndex == -1 ? this.ucmgSelected.push(ucmgState) :(this.ucmgSelected.length > 1 ? this.ucmgSelected.splice(ucmgIndex,1) : '');
    }else if(ucmgState == 'Blue'){
      this.ucmgSelected = ['Green', 'Blue', 'Yellow', 'Red'];
    }
    (this.ucmgSelected.length==3 && this.ucmgSelected.indexOf('Blue')==-1)? this.ucmgSelected.push('Blue') : this.ucmgSelected;
    if(this.olddatasource && this.olddatasource.ucmgs.length > 0){
      this.filterDataBasedonYearandStatus();
    }
  }

  searchDataSet() {
    if (this.olddatasource && this.olddatasource.ucmgs.length > 0) {
      this.applyAllFilters('');
    }
  }

  showDoc(){
    window.open(environment.docUrl+'user-guide/Capital-Demand/#ucmg-id-list-view');
  }

  showDocForTable(){
    window.open(environment.docUrl+'user-guide/Capital-Demand/#ucmg-view-table-dictionary');
  }

  getPageSizeOptions(length: number): number[] {
    const options = [];
    if (length > 10) {
      for (let i = 10; i <= length; i += 10) {
        options.push(i);
      }
      const nearestMultipleOf10 = Math.ceil(length / 10) * 10;
      if (!options.includes(nearestMultipleOf10)) {
        options.push(nearestMultipleOf10);
      }
    }
    return options;
  }

  getUcmgDetails(){
    this.showLoader = true;
    this.searchField = '';
    //if view is Segment View
    if(this.ucmgView === 'segmentView'){
      this.maintenanceService.getUCMGDetails(this.fundSegId).subscribe(
        (response: any) => {
          response = response || {};
          this.setUCMGOwnerRole(response);
          if(!this.isUCMGOwner)
            this.setPortfolioManagerRole(response);
          this.getPortfolioManagerNames(response);
          this.getUCMGOwnerNames(response.ucmgs);
          this.haveUCMGDetails(response); //put this after getPortfolioManagerNames/getUCMGOwnerNames to have updated values in dropdown and filters when data is loaded for the first time
        },
        () => {
          this.showErrMsg({ message: 'Error fetching UCMG details' });
          this.TABLE_CONFIG.totalItems = 0;
          this.showLoader = false;
        }
      );
    } 
    //if view is Leader View
    if(this.ucmgView === 'leaderView'){
      let payload: any = {};
      const queryParams = this.route.snapshot.queryParams;
      if (queryParams['L1LeaderMSID'] !== 'null') {
        payload['Leader_L1_MSID'] = queryParams['L1LeaderMSID'];
      }
      if (queryParams['L2LeaderMSID'] !== 'null') {
        payload['Leader_L2_MSID'] = queryParams['L2LeaderMSID'];
      }
      if (queryParams['L3LeaderMSID'] !== 'null') {
        payload['Leader_L3_MSID'] = queryParams['L3LeaderMSID'];
      }      
      this.maintenanceService.getUCMGLeadersList(payload).subscribe(
        (result: any) => {
          if (result) {
            this.showLoader = false;
            this.setUCMGOwnerRole(result);
            if(!this.isUCMGOwner)
              this.setPortfolioManagerRole(result);
            this.getPortfolioManagerNames(result);
            this.getUCMGOwnerNames(result.ucmgs);
            this.haveUCMGDetails(result);
            this.getFundingSegmentList(result.ucmgs);
            return result;
          } else {
            this.showLoader = false;
            this.TABLE_CONFIG.totalItems = 0;
            console.error('result getUCMGLeaderDetails no result', result);
            this.showErrMsg({ message: 'Error fetching UCMG details' });
            return {};
          }
        },
        (error) => {
          this.showLoader = false;
          this.TABLE_CONFIG.totalItems = 0;
          console.error('Error occurred while fetching UCMG leader details:', error);
          this.showErrMsg({ message: 'ERROR getting UCMG Leaders' });
        }
      );
    }
    this.showLoader = false; 
  }

  haveUCMGDetails(response: any) {
    response.ucmgs.forEach((element, index) => {
      element['id'] = index;
    });
    this.segmentName = response.Funding_Segment;
    this.tabledata =this.formatResponse(response.ucmgs)
    this.olddatasource = response;
    this.segData = response;
    this.updateTopCard();
    this.tabledata.sort((a, b) => {
      const fundingSegmentA = a['Funding_Segment']?.toLocaleLowerCase() || '';
      const fundingSegmentB = b['Funding_Segment']?.toLocaleLowerCase() || '';
      return fundingSegmentA.localeCompare(fundingSegmentB);
  });  
    this.totals = this.calculateTotals(this.tabledata);
    this.dataSourceDetails = new MatTableDataSource(this.tabledata);
    this.TABLE_CONFIG.totalItems = this.tabledata.length;
    this.onYearChange();
    if (this.olddatasource && Array.isArray(this.olddatasource.ucmgs)) {
      this.applyAllFilters(''); 
    };
    if (this.searchField) {
      this.searchDataSet();
    }
  }

  getFundingSegmentList(res:any) {
    res.forEach((element) => {
      if (element.Funding_Segment && !this.fundingSegmentList.some(item => item.name === element.Funding_Segment)) {
        this.fundingSegmentList.push({ name: element.Funding_Segment });
      }
    });

    this.selectedFundingSegmentList = this.fundingSegmentList;
  }

  getPortfolioManagerNames(results) {
    try {
      // Always start with "No Mapping"
      this.portfolioManagerList = [{ msid: "NoMapping", name: "No Mapping" }];
      if (!Array.isArray(results.ucmgs)) {
        console.warn('getPortfolioManagerNames: ucmgs is not an array', results.ucmgs);
        return;
      }
      results.ucmgs.forEach((element) => {
        if (
          element &&
          typeof element === 'object' &&
          element.Portfolio_Manager_Name &&
          element.Portfolio_Manager_MSID &&
          !this.portfolioManagerList.some(item => item.name === element.Portfolio_Manager_Name)
        ) {
          this.portfolioManagerList.push({
            name: element.Portfolio_Manager_Name,
            msid: element.Portfolio_Manager_MSID
          });
        }
      });
      // By default, select all (including "No Mapping")
      this.portfolioManagerListFullCapacity = this.portfolioManagerList.length; //for cascade check later
      this.selectedPortfolioManagerList = [...this.portfolioManagerList];
      this.previousSelectedPMList = [...this.selectedPortfolioManagerList];
    } catch (err) {
      console.error('Error in getPortfolioManagerNames:', err);
      this.portfolioManagerListFullCapacity = 0; //for cascade check later
      this.portfolioManagerList = [];
      this.selectedPortfolioManagerList = [];
      this.previousSelectedPMList = [];
    }
  }
  
  getUCMGOwnerNames(ucmgs: any[]) {
    try {
      // Always start with "No Mapping"
      this.ucmgOwnerList = [{ msid: "NoMapping", name: "No Mapping" }];
      if (!Array.isArray(ucmgs)) {
        console.warn('getUCMGOwnerNames: ucmgs is not an array', ucmgs);
        return;
      }
      ucmgs.forEach((element) => {
        if (
          element &&
          typeof element === 'object' &&
          element.UCMG_Owner_Name &&
          element.UCMG_Owner_MSID &&
          !this.ucmgOwnerList.some(item => item.name === element.UCMG_Owner_Name)
        ) {
          this.ucmgOwnerList.push({
            name: element.UCMG_Owner_Name,
            msid: element.UCMG_Owner_MSID
          });
        }
      });
      // By default, select all (including "No Mapping")
      this.ucmgOwnerListFullCapacity = this.ucmgOwnerList.length; //for cascade check later
      this.selectedUcmgOwnerList = [...this.ucmgOwnerList];
      this.previousSelectedUCMGOList = [...this.selectedUcmgOwnerList];
    } catch (err) {
      this.ucmgOwnerListFullCapacity = 0; //for cascade check later
      console.error('Error in getUCMGOwnerNames:', err);
      this.ucmgOwnerList = [];
      this.selectedUcmgOwnerList = [];
      this.previousSelectedUCMGOList = [];
    }
  }

  formatResponse(ucmgs: any): any {
    ucmgs.forEach((element) => {
      //create new key by concatinating UCMG_ID - UCMG_Name
      element['UCMG_ID_Name'] = element['UCMG_ID'] + ' - ' + element['UCMG_Name'];
      element['Leader_OT_Actuals'] = this.getLeaderOTActuals(element);
      element['OT_Variance'] =  (element['Optum_Tech_Labour'] || 0) - (element['totalOT'] || 0);
      if(this.ucmgView === 'leaderView'){ 
        element['Leader_OT_Allocation'] = element['totalOT'] || 0;
        element['OT_Variance'] = (element['Leader_OT_Allocation'] || 0) - (element['totalRunRate'] || 0);
      }
    // Set allocationFlag based on OT_Variance
      const v = element['OT_Variance'] || 0;
      element['allocationFlag'] = v > 10000
        ? 'Yellow'
        : v < -10000
        ? 'Red'
        : (v >= -10000 && v <= 10000)
        ? 'Green'
        : '';


    });
    ucmgs.sort((a, b) => a['UCMG_ID_Name'].toLocaleLowerCase() < b['UCMG_ID_Name'].toLocaleLowerCase() ? -1 : 1);
    return ucmgs;
  }

  private getLeaderOTActuals(element: any): number {
    if (Array.isArray(element?.leaders) && element.leaders.length > 0) {
      return element.leaders.reduce((sum: number, leader: any) => {
        return sum + this.parseNumericValue(leader?.Actuals ?? leader?.actuals ?? leader?.totalActuals);
      }, 0);
    }
    return this.parseNumericValue(element?.Leader_OT_Actuals ?? element?.totalActuals ?? element?.Actuals ?? element?.actuals);
  }

  private parseNumericValue(value: any): number {
    if (value === null || value === undefined || value === '') {
      return 0;
    }
    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : 0;
    }
    if (typeof value === 'string') {
      const normalized = value.replace(/[$,\s]/g, '');
      const parsed = parseFloat(normalized);
      return Number.isFinite(parsed) ? parsed : 0;
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

    handleAppicationload = async () => {
    this.showLoader = true;
    let isAdminRole = this.sharedAuthService.checkAdminSGAccess();
    if(isAdminRole != null) {
      if (this.sharedAuthService.getFundingAccessDetails('')) {
        this.TABLE_CONFIG['edit'] = true;
      }
      this.accessDataSet = true;
      this.showLoader = this.lobDataSet == true ? false : true;
    } else{
      const msId = this.sharedAuthService.getMsid();
      const secureGroups = JSON.parse(sessionStorage.getItem('secureGroups'));
      msId && this.sharedAuthService.getAccessData(msId, { 'secureGroups': secureGroups }).subscribe(accessData => {
        this.sharedAuthService.setAccessDetailsInSession(accessData);
        if (this.sharedAuthService.getFundingAccessDetails('')) {
          this.TABLE_CONFIG['edit'] = true;
        }
        this.accessDataSet = true;
        this.showLoader = this.lobDataSet == true ? false : true;
      }, (error) => {
        console.error(error);
        this.accessDataSet = true;
        this.showLoader = this.lobDataSet == true ? false : true;
      });
    }
    this.getUcmgDetails();
  }

  updateTopCard() {
    this.maintenanceService.getCapitalDemandInvestmentList().subscribe((result: any) => {
      if (result) {
        const segmentObj = result.filter(row => row.Funding_SegmentID == this.fundSegId).slice(0, 1);
        if (!segmentObj[0]?.Funding_Segment) {
          this.fundingOwner = [];
          this.fundingDelegateList = [];
        } 
        if (segmentObj && segmentObj[0]) {
          this.segmentName = segmentObj[0].Funding_Segment || '';
          this.fundingOwner = segmentObj[0].Funding_Owner || '';
        
          if (this.olddatasource && Array.isArray(this.olddatasource.fundingDelegates)) {
            this.fundingDelegateList = this.olddatasource.fundingDelegates.map(delegate => delegate.displayName || '');
          }
          if (this.olddatasource && Array.isArray(this.olddatasource.fundingOwners)) {
            this.fundingOwnerList = this.olddatasource.fundingOwners.map(owner => owner.displayName || '');
          }
        }
      } else {
        this.fundingOwner = [];
        this.fundingDelegateList = [];
      }
    }, error => {
      console.error('Error fetching capital demand investment list:', error);
      this.fundingOwner = [];
      this.fundingDelegateList = [];
      this.toaster.error(`Error fetching capital demand investment list`, '', { timeOut: 5000, positionClass: 'toast-top-center' });
    });
  }

  formatNames(name: any): any {
    if (!name) {
        return '';
    }

    // Only force-normalize case for all-upper/all-lower words (e.g. "SMITH" -> "Smith");
    // otherwise preserve existing capitalization so names like "DeLorenzo" aren't mangled.
    const capitalize = (str: string) => {
        if (!str) {
            return str;
        }
        const isUniformCase = str === str.toUpperCase() || str === str.toLowerCase();
        return isUniformCase
            ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
            : str.charAt(0).toUpperCase() + str.slice(1);
    };

    const parts = name.split(',').map(part => part.trim());
    if (parts.length === 2) {
        const [firstName] = parts[1].split(' ');
        return `${capitalize(firstName)} ${capitalize(parts[0])}`;
    }
    return name.split(' ').map(capitalize).join(' ');
  }

  showErrMsg(err: any) {
    this.showLoader = false;
    if (err && err.message) {
      this.toaster.error(err.message, '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      });
    }
  }

  showSuccessMsg(msg: any) {
    this.showLoader = false;
    if (msg) {
      this.toaster.success(msg, '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      });
    }
  }

  searchClear(){
    this.searchField = "";
  }

  onYearChange(ev:any = ''){
    if (ev) {
      this.ucmgYear = ev.data;
    } else {
      const matchedYear = this.yearList.find(year => year.name === this.ucmgYear?.name);
      this.ucmgYear = matchedYear ? matchedYear : this.yearList[0];
    }
    if(this.olddatasource.ucmgs && this.olddatasource.ucmgs.length > 0){
      this.applyAllFilters('');
    }
  }

  setSelectedValues(ev){
    let change = '';
    if(ev.type === 'Investment Status')
      this.selectedStatusList = ev.data || [];
    if(ev.type === 'Funding Segment')
      this.selectedFundingSegmentList = ev.data || [];
    if(ev.type === 'Portfolio Manager'){
      this.selectedPortfolioManagerList = ev.data || [];
      change = 'Portfolio Manager';
    }
    if(ev.type === 'UCMG Owner'){
      this.selectedUcmgOwnerList = ev.data || [];
      change = 'UCMG Owner';
    }
    if (!this.olddatasource || !Array.isArray(this.olddatasource.ucmgs)) {
      console.warn('olddatasource or ucmgs is undefined or invalid');
      return;
    }
    this.applyAllFilters(change);
  }

  applyAllFilters(change: string, cascadeList?: any) {
    // Reset data source if olddatasource or ucmgs are invalid
    if (!this.olddatasource || !Array.isArray(this.olddatasource.ucmgs)) {
      this.dataSourceDetails = new MatTableDataSource([]);
      return;
    }
    
    // Clear all filters in the child component if it exists
    if (this.capTableComponent) {
      this.capTableComponent.clearallFilter();
    }

    this.isPriorityCascadeSelected(change);
  
    // If any of these filters are defined and empty, show no rows
    if (
      (this.selectedPortfolioManagerList && this.selectedPortfolioManagerList.length === 0 && this.portfolioManagerList.length > 0) ||
      (this.selectedUcmgOwnerList && this.selectedUcmgOwnerList.length === 0 && this.ucmgOwnerList.length > 0) ||
      (this.selectedStatusList && this.selectedStatusList.length === 0 && this.statusList.length > 0)
    ) {
      this.dataSourceDetails = new MatTableDataSource([]);
      this.countColors({ucmgs: []});
      return;
    }
  
    // Deep clone the original data to avoid mutating it
    let dataSourceArr: Array<any> = _.cloneDeep(this.olddatasource.ucmgs || []);
    const filterValue = this.searchField ? this.searchField.trim().toLowerCase() : '';
    const investmentStatus = this.selectedStatusList.map(val => val?.name?.toLocaleLowerCase());

    //Check if portfolio manager list and ucmg owner list cascade from a selection
    this.checkPMListandUCMGOListForCascade(dataSourceArr);
  
    // Apply all filters
    const filterArr = dataSourceArr.filter(val => {

      let isPortfolioManagerMatch = true;
      if (this.selectedPortfolioManagerList && this.selectedPortfolioManagerList.length > 0) {
        isPortfolioManagerMatch = this.selectedPortfolioManagerList.some(manager => {
          // If "No Mapping" is selected, match UCMGs with null/empty Portfolio_Manager_MSID or Portfolio_Manager_Name
          if (manager.msid === "NoMapping") {
            return !val.Portfolio_Manager_MSID || !val.Portfolio_Manager_Name;
          }
          // Otherwise, match by MSID
          return val.Portfolio_Manager_MSID === manager.msid;
        });
      }
  
      let isUcmgOwnerMatch = true;
      if (this.selectedUcmgOwnerList && this.selectedUcmgOwnerList.length > 0) {
        isUcmgOwnerMatch = this.selectedUcmgOwnerList.some(owner => {
          // If "No Mapping" is selected, match UCMGs with null/empty UCMG_Owner_MSID or UCMG_Owner_Name
          if (owner.msid === "NoMapping") {
            return !val.UCMG_Owner_MSID || !val.UCMG_Owner_Name;
          }
          // Otherwise, match by MSID
          return val.UCMG_Owner_MSID === owner.msid;
        });
      }
  
      let isYearMatch = true;
      if (this.ucmgYear && this.ucmgYear.name) {
        isYearMatch = val.fiscalYear == this.ucmgYear.name;
      }
  
      let isStatusMatch = true;
      if (investmentStatus.length > 0) {
        isStatusMatch = investmentStatus.indexOf(val.investmentStatus?.toLocaleLowerCase()) !== -1;
      }
  
      let isFlagMatch = true;
      if (this.ucmgSelected && this.ucmgSelected.length > 0) {
        isFlagMatch = this.ucmgSelected.indexOf(val.allocationFlag) !== -1;
      }
  
      let isFundingSegmentMatch = true;
      if (this.selectedFundingSegmentList) {
        if (this.selectedFundingSegmentList.length === 0 && this.fundingSegmentList.length > 0) {
          // If user has deselected all, hide all rows
          isFundingSegmentMatch = false;
        } else if (this.selectedFundingSegmentList.length > 0) {
          isFundingSegmentMatch = this.selectedFundingSegmentList.some(segment => {
            const fundingSegment = val.Funding_Segment?.trim().toLowerCase();
            const segmentName = segment.name?.trim().toLowerCase();
            return segmentName === fundingSegment;
          });
        }
      }
  
      let isSearchItemExist = true;
      if (filterValue) {
        isSearchItemExist =
          val.UCMG_ID?.toLocaleLowerCase().indexOf(filterValue) !== -1 ||
          val.UCMG_Name?.toLocaleLowerCase().indexOf(filterValue) !== -1;
      }
  
      return (
        isPortfolioManagerMatch &&
        isUcmgOwnerMatch &&
        isYearMatch &&
        isStatusMatch &&
        isFlagMatch &&
        isFundingSegmentMatch &&
        isSearchItemExist
      );
    });

    this.cascadeFilters(filterArr, change, cascadeList);
  
    filterArr.sort((a, b) => {
      const segA = a['Funding_Segment']?.toLocaleLowerCase() || '';
      const segB = b['Funding_Segment']?.toLocaleLowerCase() || '';
      if (segA < segB) return -1;
      if (segA > segB) return 1;
      // If segments are equal, sort by UCMG_Name as secondary
      const nameA = a['UCMG_Name']?.toLocaleLowerCase() || '';
      const nameB = b['UCMG_Name']?.toLocaleLowerCase() || '';
      return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
    });
    this.countColors({ucmgs: filterArr})
    this.totals = this.calculateTotals(filterArr);
    this.dataSourceDetails = new MatTableDataSource(filterArr);
  }

  cascadeFilters(filterArr: Array<any>, change: string, cascadeList?: any) {
    // This function updates the options in the other dropdown based on the selection of Portfolio Manager or UCMG Owner
    // only one dropdown can cascade at a time so one dropdown has "priority" over the other until reset (both dropdowns at full capacity again)
    if (change === '') {
      return; // No change, no need to cascade
    }else if (change === 'Portfolio Manager'){
      cascadeList = this.selectedPortfolioManagerList;
    } else if (change === 'UCMG Owner'){
      cascadeList = this.selectedUcmgOwnerList;
    }

    if (!Array.isArray(filterArr)) {
      console.warn('Something went wrong in cascadeFilters()', filterArr);
      return;
    }

    //No longer cascading both ways, UCMG Owner not required
    //We are doing left to right cascading only

    if(change === 'Portfolio Manager'){
        this.ucmgOwnerList = [];
        filterArr.forEach((element) => {
          if (
            element &&
            typeof element === 'object' &&
            !this.ucmgOwnerList.some(item => item.name === element.UCMG_Owner_Name) &&
            // ensure element row matches selected UCMG Owners
            cascadeList.some(manager => {
              if (manager.msid === "NoMapping" && (element.Portfolio_Manager_MSID == null || element.Portfolio_Manager_MSID === 'NoMapping')) {return true; } 
              else { return manager.msid === element.Portfolio_Manager_MSID; }
            })
          ) {
            if(element.UCMG_Owner_Name != null && element.UCMG_Owner_MSID != null){
              this.ucmgOwnerList.push({
                name: element.UCMG_Owner_Name,
                msid: element.UCMG_Owner_MSID
              });
            } else if (!this.ucmgOwnerList.some(item => (item.name === 'No Mapping') || (item.msid ==='NoMapping'))){
              this.ucmgOwnerList.push({
                name: 'No Mapping',
                msid: 'NoMapping'
              });
            }
          }
      });
    }

    //record previous UCMG Owner selected list
    if(change === 'Portfolio Manager') { this.selectedUcmgOwnerList = [...this.ucmgOwnerList]; }
    this.previousSelectedUCMGOList = [...this.selectedUcmgOwnerList];
    //update previous portfolio manager selected list
    this.previousSelectedPMList = [...this.selectedPortfolioManagerList];
  }

  checkPMListandUCMGOListForCascade(dataSourceArr?: Array<any>) {
    //compare selectedPortfolioManagerList and previousSelectedPMList

    let change = '';
    if(this.previousSelectedPMList.length != this.selectedPortfolioManagerList.length ){ 
      change = 'Portfolio Manager'; 
      //update ucmgOwnerLists
      this.cascadeFilters(dataSourceArr, change, this.selectedPortfolioManagerList);
    }
    if(this.previousSelectedUCMGOList.length != this.selectedUcmgOwnerList.length ){ 
      change = 'UCMG Owner'; 
      //update portfolioManagerLists
      this.cascadeFilters(dataSourceArr, change, this.selectedUcmgOwnerList);
    }

    if(change === '') { return; }
  }

  isPriorityCascadeSelected(change){
    if(change === 'Portfolio Manager' &&
      (this.getCascadePriority() === 'Portfolio Manager' || this.getCascadePriority() === '') &&
      this.selectedPortfolioManagerList.length === 0
    ){
      this.ucmgOwnerList = [];
      this.selectedUcmgOwnerList = [];
      this.previousSelectedUCMGOList = [];
    }

    //No need for UCMG Owner to Portfolio Manager cascading - doing left to right only
  }

  getCascadePriority() {
    // if No cascading is being done, return '' for no change
    if(this.portfolioManagerList.length === this.portfolioManagerListFullCapacity && 
      this.ucmgOwnerList.length === this.ucmgOwnerListFullCapacity){
        return ''; //untouched, no cascading is being done atm
    }
    if (this.portfolioManagerList.length === this.portfolioManagerListFullCapacity){
      return 'Portfolio Manager';
    }
    //No need for UCMG Owner to Portfolio Manager cascading - doing left to right only
  }

  filterDataBasedonYearandStatus(){
    const filterValue = this.searchField ?  this.searchField.trim().toLowerCase(): '';
    const investmentStatus = this.selectedStatusList.map((val)=>val?.name?.toLocaleLowerCase());
    const dataSourceArr:Array<any> = _.cloneDeep(this.olddatasource.ucmgs || []);
    const filterArr:Array<any> = dataSourceArr.filter((val)=>{
      let isSearchItemExist : boolean = false;
      if(filterValue && (
        val.UCMG_ID?.toLocaleLowerCase().indexOf(filterValue?.toLocaleLowerCase()) !== -1 ||
        val.UCMG_Name?.toLocaleLowerCase().indexOf(filterValue?.toLocaleLowerCase()) !== -1)){
        isSearchItemExist = true;
      }
      if(filterValue == '' || (filterValue && isSearchItemExist)){
        if(this.ucmgYear?.name == val.fiscalYear 
          && investmentStatus.indexOf(val.investmentStatus?.toLocaleLowerCase()) !== -1 && this.ucmgSelected.indexOf(val.allocationFlag) !== -1){
          return val;
        }
      }
      })
    filterArr.sort((a, b) => a['UCMG_Name']?.toLocaleLowerCase() < b['UCMG_Name']?.toLocaleLowerCase() ? -1 : 1);
    this.totals = this.calculateTotals(filterArr);
    this.dataSourceDetails = new MatTableDataSource(filterArr);
  }

  filterDataBasedOnPortfolioManagerAndUcmgOwner() {
    const dataSourceArr:Array<any> = _.cloneDeep(this.olddatasource.ucmgs || []);
    const filterArr: Array<any> = dataSourceArr.filter((val) => {
      let isPortfolioManagerMatch = true;
      let isUcmgOwnerMatch = true;
  
      if (this.selectedPortfolioManagerList && this.selectedPortfolioManagerList.length > 0) {
        isPortfolioManagerMatch = this.selectedPortfolioManagerList.some((manager) => {
          return val.Portfolio_Manager_MSID === manager.msid;
        });
      }
  
      if (this.selectedUcmgOwnerList && this.selectedUcmgOwnerList.length > 0) {
        isUcmgOwnerMatch = this.selectedUcmgOwnerList.some((owner) => {
          return val.UCMG_Owner_MSID === owner.msid;
        });
      }
      // Only filter by the criteria that are selected
      return isPortfolioManagerMatch && isUcmgOwnerMatch;
    });
    this.dataSourceDetails = new MatTableDataSource(filterArr);
  }

  filterDataBasedonFundingSegment() {
    if (!this.selectedFundingSegmentList || this.selectedFundingSegmentList.length === 0) {
      this.dataSourceDetails = new MatTableDataSource([]);
      return;
    }
  
    let filteredData = this.dataSourceDetails.filteredData.filter((item) =>
      this.selectedFundingSegmentList.some((segment) => {
        const fundingSegment = item.Funding_Segment?.trim().toLowerCase();
        const segmentName = segment.name?.trim().toLowerCase();
        return segmentName === fundingSegment;
      })
    );
  
    // Update the data source with the filtered data
    this.totals = this.calculateTotals(filteredData);
    this.dataSourceDetails = new MatTableDataSource(filteredData);
  }

  exportToCsv(){
    if (this.dataSourceDetails.data && this.dataSourceDetails.data.length) {
      const exportData = this.dataSourceDetails.data;
      const dataValues = [];
      const leadersDataValues = [];
      exportData.map((ele) => {
          let leadersData = [];
          if (ele.leaders && ele.leaders.length > 0) {
            leadersData = ele.leaders;
          }
          const obj: any = {};
          obj['Funding Segment ID'] = ele['Funding_SegmentID'] ? ele['Funding_SegmentID'] : '';
          obj['Funding Segment'] = ele['Funding_Segment'] ? ele['Funding_Segment'] : '';
          obj['UCMG ID'] = ele['UCMG_ID'] ? ele['UCMG_ID'] : '';
          obj['UCMG Name'] = ele['UCMG_Name'] ? ele['UCMG_Name'] : '';
          if(this.ucmgView === 'segmentView'){
            obj['ACAP'] = this.convertToString(ele['ACAP']);
            obj['Optum Tech Labor'] = this.convertToString(ele['Optum_Tech_Labour']);
            obj["Leader OT Allocation"] = this.convertToString(ele['totalOT']) ? this.convertToString(ele['totalOT']) : '';
            obj['Advisory Services'] = this.convertToString(ele['Advisory_Service']);
            obj['Business Labor'] = this.convertToString(ele['Bussiness_Labour']);
            obj['Hardware/Software'] = this.convertToString(ele['Hardware_Software']);
            obj['Other Chargebacks'] = this.convertToString(ele['Other_Chargebacks']);
            obj['Professional Fees'] = this.convertToString(ele['Professional_Fees']);
            obj['Portfolio_Manager_Name'] = ele['Portfolio_Manager_Name'];
            obj['Portfolio_Manager_MSID'] = ele['Portfolio_Manager_MSID'];
            obj['UCMG_Owner_Name'] = ele['UCMG_Owner_Name'];
            obj['UCMG_Owner_MSID'] = ele['UCMG_Owner_MSID'];
          }else{
            obj["Leader OT Allocation"] = this.convertToString(ele['totalOT']) ? this.convertToString(ele['totalOT']) : '';
            obj["Leader Run Rate"] = this.convertToString(ele['totalRunRate']) ? this.convertToString(ele['totalRunRate']) : '';
            obj["Leader OT Actuals"] = this.convertToString(ele['Leader_OT_Actuals']) ? this.convertToString(ele['Leader_OT_Actuals']) : '';
            obj["Leader Variance"] = this.convertToString(ele['OT_Variance']) ? this.convertToString(ele['OT_Variance']) : '';
            obj['Portfolio Manager Name'] = ele['Portfolio_Manager_Name'] ? ele['Portfolio_Manager_Name'] : '';
            obj['Portfolio Manager MSID'] = ele['Portfolio_Manager_MSID'] ? ele['Portfolio_Manager_MSID'] : '';
            obj['UCMG Owner Name'] = ele['UCMG_Owner_Name'] ? ele['UCMG_Owner_Name'] : '';
            obj['UCMG Owner MSID'] = ele['UCMG_Owner_MSID'] ? ele['UCMG_Owner_MSID'] : '';
          }
          obj['Fiscal Year'] = ele['fiscalYear'] ? ele['fiscalYear'] : '';
          obj['Investment Status'] = ele['investmentStatus'] ? ele['investmentStatus']:'';
          obj['Comments'] = ele['comments']? ele['comments']:'';
          dataValues.push(obj);
          leadersData.map((item) => {
            const ob = {};
            ob['UCMG ID'] = item['UCMG_ID'];
            ob['UCMG Name'] = ele['UCMG_Name'] ? ele['UCMG_Name'] : '';
            ob['Funding Segment'] = ele['Funding_Segment'] ? ele['Funding_Segment'] : '';
            ob['Fiscal Year'] = item['fiscalYear'] ? item['fiscalYear'] : '';
            ob['Investment Status'] = ele['investmentStatus'] ? ele['investmentStatus']:'';
            ob['Leader Name'] = item['leader_name'] ? item['leader_name'] : '';
            ob['Leader MSID'] = item['leader_msid'] ? item['leader_msid'] : '';
            ob['Optum Tech Labor'] = this.convertToString(item['optum_tech_labour']);
            ob['Leader OT Actuals'] = this.convertToString(item['Actuals'] ?? item['actuals'] ?? item['totalActuals']);
            leadersDataValues.push(ob);
          });
      });
      const fileName = 'Capital-Demand-Investment';
      this.exportService.exportToExcel(fileName, [dataValues, leadersDataValues],['UCMG','Leader']);
    }
  }

  convertToString(value) {
    let valueToReturn = '';
    if (value != null) {
        // Format the value to two decimal places
        value = parseFloat(value).toFixed(2);
        // Split the value into integer and decimal parts
        const parts = value.split(".");
        // Check if the decimal part is .00
        if (parts[1] === "00") {
            valueToReturn = parts[0];
        } else {
            valueToReturn = parts.join(".");
        }
    }
    return valueToReturn;
}

  countColors(array) {
    const filterValue = this.searchField ?  this.searchField.trim().toLowerCase() : ''; //search textfield filtervalue
    const colorCounts = { Green: 0, Blue: 0, Yellow: 0, Red: 0 };
    const colorCurrency = { Green: 0, Blue: 0, Yellow: 0, Red: 0 };
    array = array.ucmgs || [];
    array.forEach(obj => {
        if (
            obj.fiscalYear === this.ucmgYear?.name.toString()
            && this.isStatusInArray(obj.investmentStatus, this.selectedStatusList)
            && (obj.UCMG_ID.includes(filterValue) || obj.UCMG_Name.toLowerCase().includes(filterValue))
        ) {
            const color = obj.allocationFlag;
            if (colorCounts[color] !== undefined) {
                colorCounts[color]++;
            }
            colorCurrency[color] = colorCurrency[color] + this.getCurrencyTotals(obj);
        }
    });

    // The blue category is now calculated as the sum of Green, Yellow, and Red categories
    this.totalApps.green = colorCounts.Green;
    this.totalApps.blue = this.calculateBlueCategory(colorCounts);
    this.totalApps.yellow = colorCounts.Yellow;
    this.totalApps.red = colorCounts.Red;

 
    colorCurrency.Blue = this.calculateBlueCategory(colorCurrency);


    this.totalCurrency.green = colorCurrency.Green;
    this.totalCurrency.blue = colorCurrency.Blue;
    this.totalCurrency.yellow = colorCurrency.Yellow;
    this.totalCurrency.red = colorCurrency.Red;
  }

  private calculateBlueCategory(data: any): number {
    return data.Green + data.Yellow + data.Red;
  }

  isStatusInArray(status, statusArray) {
    if (!status || !Array.isArray(statusArray) || statusArray.length === 0) {
      return false;
    }
    const upperCaseArray = statusArray.map(s => s.name.toUpperCase());
    const upperCaseStatus = status.toUpperCase();

    return upperCaseArray.includes(upperCaseStatus);
  }

  getCurrencyTotals(obj: any) {
    let total = 0;
    const keys = [
      'OT_Variance',
    ];
    keys.forEach(key => {
        total += obj[key] ? obj[key] : 0;
    });
    return total;
  }

  convertExcelDecimal(value) {
    try {
      if (value === null || value === undefined) {
          return '';
      }
      const num = parseFloat(value);
      if (isNaN(num)) {
          return value.toString();
      }
      return num % 1 === 0 ? num.toString() : num.toFixed(2);
    } catch (error) {
        console.error('Error converting Excel decimal:', error);
        return '';
    }
  }

  abbreviateNumber(num) {
    num = Math.abs(num);
    return num;
  }

  formatLeadersData(L1, L2, L3){
    let leaderArr = [];
    if(L1){
      leaderArr.push({Leader: L1, Level: 1})
    }
    if(L2){
      leaderArr.push({Leader: L2, Level: 2})
    }
    if(L3){
      leaderArr.push({Leader: L3, Level: 3})
    }
    return leaderArr;
  }

calculateTotals(data: any[]): { totalACAP: number; totalOptumTechLabor: number; totalLeaderOTAllocation: number } {
  if (!Array.isArray(data)) {
    this.toaster.error('Invalid data for totals calculation', '', { timeOut: 5000, positionClass: 'toast-top-center' });
    return { totalACAP: 0, totalOptumTechLabor: 0, totalLeaderOTAllocation: 0 };
  }
  return data.reduce((acc, item) => {
    acc.totalACAP += item.ACAP || 0;
    acc.totalOptumTechLabor += item.Optum_Tech_Labour || 0;
    acc.totalLeaderOTAllocation += item.totalOT || 0;
    return acc;
  }, { totalACAP: 0, totalOptumTechLabor: 0, totalLeaderOTAllocation: 0 });
}

navigateToCapitalDemand(){
  const queryParams = this.route.snapshot.queryParams;
  const segmentView = queryParams['segmentView'] ? queryParams['segmentView'] : 'false';
  const leaderView = queryParams['leaderView'] ? queryParams['leaderView'] : 'false';
  const leaders = queryParams['leader'] ? queryParams['leader'] : '';
  const fiscalYear = queryParams['fiscalYear'];
   const invtStatus = queryParams['invstStatus'];
  const selectedStatus = queryParams['selectedStatus'];
  const ucmgYear = queryParams['ucmgYear'];
  const searchedText = queryParams['searchedText'] || '';
  console.log('Navigating with params:', { segmentView, fiscalYear, invtStatus, selectedStatus, ucmgYear, searchedText });
  this.router.navigate(['/maintenanceV4/Capital-Demand'], { queryParams: { segmentView: segmentView , investmentStatus: invtStatus , fiscalYear: fiscalYear, selectedStatus: selectedStatus, ucmgYear: ucmgYear, searchedText: searchedText, leaderView: leaderView, leaders: leaders } })
    .catch(err => {
      this.toaster.error('Navigation failed', '', { timeOut: 5000, positionClass: 'toast-top-center' });
      console.error('Navigation error:', err?.message || err);
    });
}

  handleFilteredDataChange(filteredData: any[]): void {
    if (filteredData && filteredData.length > 0) {
      // Calculate totals for filtered data
      const totals = this.calculateTotals(filteredData);
      
      // Store filtered totals for use in UI
      this.totals = totals;
      
      // Update color counts based on filtered data
      this.countColors({ ucmgs: filteredData });
    } else {
      // No filtered data, reset to original data totals
      this.filteredTotals = null;
      if (this.tabledata && this.tabledata.length > 0) {
        const totals = this.calculateTotals(this.tabledata);
        this.totals = totals;
        this.countColors({ ucmgs: this.tabledata });
      }
    }
  }

  configureTableColumns(){
    if(this.ucmgView === 'segmentView'){
      this.TABLE_COLUMNS = [
        {
          key : 'allocationFlag',      
          labelKey: 'allocationFlag',
          label: 'Flag',
          width: '5% !important',
          edit: false,
          addNew: false,
          filter: false,
          search: '',
          searchValue: '',
          link: false,
          paddingHeader:"0 1% 0 1% !important",
          sortable:false
        }, 
        {
          key : 'UCMG_ID_Name',      
          labelKey: 'UCMG_ID_Name',
          label: 'UCMG ID - Name',
          width: '10% !important',
          paddingHeader:"0 1% 0 1% !important",
          edit: true,
          addNew: true,
          filter: true,
          search: '',
          searchValue: '',
          validations: [{ 'required': true }],
          sortable: true,
         
        },
        {
          key: 'ACAP',
          label: 'Total Forecast',
          width: '12% !important',
          textAlign: 'center !important',
          filter: true,
          currency: true,
          paddingHeader:"0 1% 0 1% !important",
          sortable: true,
        },
        {
          key: 'Optum_Tech_Labour',
          labelKey: 'Optum_Tech_Labour',
          label: 'OT Labor',
          width: '11% !important',
          textAlign: 'center !important',
          filter: true,
          currency: true,
          // validations: [{ 'required': true }]
          paddingHeader:"0 1% 0 1% !important",
          sortable: true,
        },
        {
          key: 'Leader_OT_Actuals',
          label: 'OT Actuals',
          width: '10% !important',
          textAlign: 'center !important',
          filter: true,
          currency: true,
          paddingHeader:"0 1% 0 1% !important",
          sortable: true,
        },
        {
          key: 'OT_Variance',
          labelKey: 'OT_Variance',
          label: 'OT Variance',
          textAlign: 'center !important',
          filter: true,
          currency: true,
          width: '11% !important',
          paddingHeader:"0 1% 0 1% !important",
          sortable: true,
          
          
        },
        {
          key: 'Advisory_Service',
          labelKey: 'Advisory_Service',
          label: 'OAS',
          width: '7% !important',
          textAlign: 'center !important',
          filter: true,
          currency: true,
          // paddingHeader:"0 1% 0 1% !important",
          sortable: true,
        },
        {
          key: 'Bussiness_Labour',
          labelKey: 'Bussiness_Labour',
          label: 'Biz Labor',
          width: '11% !important',
          textAlign: 'center !important',
          filter: true,
          currency: true,
          paddingHeader:"0 1% 0 1% !important",
          sortable: true,
        },
        {
          key: 'Hardware_Software',
          labelKey: 'Hardware_Software',
          label: 'HW/SW',
          width: '10% !important',
          textAlign: 'center !important',
          filter: true,
          currency: true,
          paddingHeader:"0 1% 0 1% !important",
          sortable: true,
        },
        {
          key: 'Other_Chargebacks',
          labelKey: 'Other_Chargebacks',
          label: 'Other',
          width: '10% !important',
          textAlign: 'center !important',
          filter: true,
          currency: true,
          paddingHeader:"0 1% 0 1% !important",
          sortable: true,
        },
        {
          key: 'Professional_Fees',
          labelKey: 'Professional_Fees',
          label: 'Pro Fees',
          width: '11% !important',
          textAlign: 'center !important',
          filter: true,
          currency: true,
          paddingHeader:"0 1% 0 1% !important",
          sortable: true,
          isLastColumn: true
        }
      ];
    }
    if(this.ucmgView === 'leaderView'){
      this.TABLE_COLUMNS = [
        {
          key : 'allocationFlag',      
          labelKey: 'allocationFlag',
          label: 'Flag',
          width: '5% !important',
          edit: false,
          addNew: false,
          filter: false,
          search: '',
          searchValue: '',
          link: false,
          padding:"0 0.81% 0 1.94% !important",
          sortable: false
         
        }, 
        {
          key : 'Funding_Segment',      
          labelKey: 'Funding_Segment',
          label: 'Funding Segment',
          width: '8% !important',
          edit: false,
          addNew: false,
          filter: true,
          search: '',
          searchValue: '',
          sortable: true,
        },
        {
          key : 'UCMG_ID_Name',      
          labelKey: 'UCMG_ID_Name',
          label: 'UCMG ID - Name',
          width: '10% !important',
          edit: true,
          addNew: true,
          filter: true,
          search: '',
          searchValue: '',
          validations: [{ 'required': true }],
          sortable: true,
        },
        {
          key: 'Leader_OT_Allocation',
          labelKey: 'optum_tech_labour',
          label: 'Leader OT Allocation',
          width: '10% !important',
          filter: true,
          textAlign: 'center !important',
          currency: true,
           paddingHeader:"0 0.5% 0 4.5% !important",
           sortable:true,
           isLastColumn: true
        },
                {
          key: 'totalRunRate',
          label: 'Leader Run Rate',
          width: '10% !important',
          filter: true,
          textAlign: 'center !important',
          currency: true,
           paddingHeader:"0 0.5% 0 5% !important",
          sortable: true,
        },
        {
          key: 'Leader_OT_Actuals',
          label: 'Leader OT Actuals',
          width: '10% !important',
          filter: true,
          textAlign: 'center !important',
          currency: true,
          decimals: 2,
          paddingHeader:"0 0.5% 0 5% !important",
          sortable: true,
        },
        {
          key: 'OT_Variance',
          labelKey: 'Optum_Tech_Labour',
          label: 'Leader Variance',
          width: '10% !important',
          filter: true,
          textAlign: 'center !important',
          currency: true,
           paddingHeader:"0 0.5% 0 5.5% !important",
          sortable: true,
        },
      ];
    }

  }

  getUCMGLeaderDetails(L1Leader?: string, L2Leader?: string, L3Leader?: string) {
    this.showLoader = true;
    let payload = {
      "Leader_L1_MSID": L1Leader ? L1Leader : null,
      "Leader_L2_MSID": L2Leader ? L2Leader : null,
      "Leader_L3_MSID": L3Leader ? L3Leader : null
    };
    this.maintenanceService.getUCMGLeadersList(payload).subscribe(
      (result: any) => {
        if (result) {
          this.showLoader = false;
          return result;
        } else {
          this.showLoader = false;
          console.error('result getUCMGLeaderDetails no result', result);
          return {};
        }
      },
      (error) => {
        this.showLoader = false;
        console.error('Error fetching UCMG Leader details:', error);
        this.toaster.error(`Error fetching UCMG Leader details`, '', { timeOut: 5000, positionClass: 'toast-top-center' });
        return {};
      }
    );
  }

}